// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.2 3.48H7.13',
  'M2.2 3.48L1.7 8.65C1.65 9.14 1.85 9.52 2.2 9.87L6.83 13.96C7.16 14.29 7.56 14.51 8.02 14.37C8.68 14.17 8.97 13.41 8.46 12.9',
  'M11.75 3.48H13.8L14.3 8.65C14.36 9.23 13.98 9.7 13.4 9.7H12.5',
  'M11.75 3.48L10.98 3.05C9.64 2.3 8.07 2.54 7 3.61L5.05 5.56C4.54 6.07 4.54 6.9 5.05 7.41C5.56 7.92 6.39 7.92 6.9 7.41L7.55 6.76C8.15 6.16 9.12 6.16 9.72 6.76L12.16 9.2C12.67 9.71 12.67 10.54 12.16 11.05C11.65 11.56 10.82 11.56 10.31 11.05L9.35 10.09',
  'M10.31 11.05C10.82 11.56 10.82 12.39 10.31 12.9C9.8 13.41 8.97 13.41 8.46 12.9L7.5 11.94',
];
